(() => {
  const init = (wheel) => {
    if (wheel.dataset.mdWheelReady) return;
    wheel.dataset.mdWheelReady = 'true';
    const ring = wheel.querySelector('[data-md-wheel-ring]');
    const skipFirst = wheel.dataset.skipFirst === 'true';
    const exclude = (wheel.dataset.exclude || '')
      .split(',')
      .map((part) => part.trim().toLowerCase())
      .filter(Boolean);

    const host = wheel.closest('.shopify-section');
    let sections = [...document.querySelectorAll('main .shopify-section, #MainContent > .shopify-section')]
      .filter((section) => section !== host && section.offsetHeight > 0);
    sections = [...new Set(sections)];
    if (skipFirst) sections = sections.slice(1);

    const stops = [];
    sections.forEach((section) => {
      const eyebrow = section.querySelector('[class*="__eyebrow"]');
      const label = (eyebrow ? eyebrow.textContent : '').replace(/\s+/g, ' ').trim();
      if (!label) return;
      if (exclude.some((word) => label.toLowerCase().includes(word))) return;
      stops.push({ section, label });
    });
    if (stops.length < 2) return;

    const items = stops.map((stop, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'md-wheel__item';
      button.style.setProperty('--_i', i);
      button.innerHTML = '<i></i><span></span>';
      button.querySelector('span').textContent = stop.label;
      button.addEventListener('click', () => {
        const top = stop.section.getBoundingClientRect().top + window.scrollY - 24;
        const lenis = window.md && window.md.lenis;
        if (lenis && typeof lenis.scrollTo === 'function') lenis.scrollTo(top);
        else window.scrollTo({ top, behavior: 'smooth' });
      });
      ring.append(button);
      return button;
    });
    wheel.hidden = false;

    let frame = 0;
    let current = -1;
    const update = () => {
      frame = 0;
      const mid = window.innerHeight * 0.45;
      let active = 0;
      stops.forEach((stop, i) => {
        if (stop.section.getBoundingClientRect().top <= mid) active = i;
      });
      const first = stops[0].section.getBoundingClientRect();
      const last = stops[stops.length - 1].section.getBoundingClientRect();
      const visible = first.top < window.innerHeight * 0.6 && last.bottom > window.innerHeight * 0.3;
      wheel.classList.toggle('is-visible', visible);
      if (active !== current) {
        current = active;
        wheel.style.setProperty('--_progress', active);
        items.forEach((item, i) => {
          item.classList.toggle('is-active', i === active);
          item.classList.toggle('is-near', Math.abs(i - active) === 1);
          if (i === active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      }
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule);
    update();
  };

  const run = () => document.querySelectorAll('[data-md-wheel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
